import { memo } from 'react';
import Layout from 'antd/lib/layout';
import { Content } from 'antd/lib/layout/layout';

import Routes from 'routes/Routes';
import ErrorConnection from 'components/ErrorConnection/ErrorConnection';
import Header from 'components/Header/Header';
import LeftPanel from 'components/LeftPanel/LeftPanel';
import { isAuthenticatedUserSelector, isLoadingUserSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import withNecessaryData from 'hocs/withNecessaryData';
import withPusher from 'hocs/withPusher';
import withUser from 'hocs/withUser';
import { MainStyled } from 'components/Main/styled';

const Main = () => {
  const isAuthenticatedUser = useTypedSelector(isAuthenticatedUserSelector);
  const isLoadingUser = useTypedSelector(isLoadingUserSelector);

  if (isLoadingUser) {
    return null;
  }

  if (isAuthenticatedUser) {
    return (
      <MainStyled>
        <LeftPanel />
        <Layout>
          <Header />
          <Content>
            <Routes />
          </Content>
        </Layout>
        <ErrorConnection />
      </MainStyled>
    );
  }

  return (
    <MainStyled>
      <Routes />
    </MainStyled>
  );
};

export default withUser(withPusher(withNecessaryData(memo(Main))));
